export enum RequestStatusActionsEnum {
  editPerson = "editPerson",
  resendRequest = "resendRequest",
  changeDeadline = "changeDeadline",
  changeDeadlineDays = "changeDeadlineDays",
  changeSignatureProvider = "changeSignatureProvider",
  openPreview = "openPreview",
  // Request Events
  /** <summary>
  /// The download action for a request.
  **/
  Download = "Download",
  /** <summary>
  /// The export action for a request.
  **/
  Export = "Export",
  // Request Events
  /** <summary>
  /// The download action for a request.
  **/
  DownloadDocument = "DownloadDocument",
  /** <summary>
  /// The export action for a request.
  **/
  ExportDocument = "ExportDocument",
  /** <summary>
  /// The purge action.
  **/
  Purge = "Purge",
  /** <summary>
  /// The delete action.
  **/
  Delete = "Delete",
  /** <summary>
  /// The withdrawn action.
  **/
  Withdrawn = "Withdrawn",
  /** <summary>
  /// The restore action.
  **/
  Restore = "restore",
  /** <summary>
  /// The become an owner action.
  **/
  BecomeOwner = "BecomeOwner",
  /** <summary>
  /// The view log action.
  **/
  Viewlog = "Viewlog",
  /** <summary>
  /// The open preview action.
  **/
  OpenPreview = "OpenPreview",
  /** <summary>
  /// The open email preview action.
  **/
  openEmailPreview = "openEmailPreview",
  /** <summary>
  /// Show document details
  **/
  showDocumentDetails = "showDocumentDetails",
  /** <summary>
  /// Edit request
  **/
  EditRequest = "editRequest",
  /** <summary>
  /// Go to request
  **/
  GoToRequest = "goToRequest",
  /** <summary>
  /// Edit filing data
  **/
  EditFilingData = "editFilingData"
}